import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEqual from "lodash/isEqual";
import get from "lodash/get";
import RecommendationsList from './RecommendationsList'
import RecommendationsGrid from './RecommendationsGrid'
import { getRecommendations, addReferrer } from '../../actions/recommendations/recommendationActions';

const propTypes = {
    location: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,

    pageReferrer: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    windowWidth: PropTypes.number,

    getRecommendations: PropTypes.func.isRequired,
    recommendations: PropTypes.object,
    auth: PropTypes.object
};

export class Recommendations extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            includeNotReservable: false,
            includeUnavailable: false
        };
    }

    componentDidMount() {
        this.getRecommendations();
    }

    componentDidUpdate(prevProps) {
        const {
            location,
            startDate,
            endDate
        } = this.props;

        const prevAccount = get(prevProps.auth,'account.account.account_id', null);
        const thisAccount = get(this.props.auth,'account.account.account_id', null);
        if (
            !isEqual(location, prevProps.location)
            || !isEqual(thisAccount, prevAccount)
            || !isEqual(startDate, prevProps.startDate)
            || !isEqual(endDate, prevProps.endDate)
        ) {
            this.getRecommendations();
        }
    }

    getRecommendations = () => {
        const account = get(this.props.auth,'account.account.account_id', null);
        let model = "nearby";
        if (account) {
            model = "nearby2";
        }
        const recommendationParams = {
            includeNotReservable: this.state.includeNotReservable,
            includeUnavailable: this.state.includeUnavailable,
            model,
            location: this.props.location,
            startDate: this.props.startDate,
            endDate: this.props.endDate
        };
        this.props.getRecommendations(recommendationParams);
        this.setState({
            model
        });
        /*
        // dynamic model selection is currently disabled
        SessionFeatureFlags.fetchFeatureFlagValue('recommendation-models')
            .then((model)=>{
                SessionFeatureFlags.fetchUserGeoIp()
                    .then((geoip)=>{
                        const recommendationParams = {
                            includeNotReservable: this.state.includeNotReservable,
                            includeUnavailable: this.state.includeUnavailable,
                            model,
                            location: this.props.location,
                            account,
                            area: geoip.geohash ? geoip.geohash.substring(0,3) : null,
                            state: geoip.region_code ? geoip.region_code.toLowerCase() : null,
                            startDate: this.props.startDate,
                            endDate: this.props.endDate
                        };
                        this.props.getRecommendations(recommendationParams);
                        this.setState({
                            model
                        })
                    });
            })
         */
    };

    onCardSelect = (item, url, index) => {
        const referrerParams = {
            model: this.state.model,
            pageReferrer: this.props.pageReferrer,
            entityId: item.entity_id,
            entityType: item.entity_type,
            locationId: this.props.location,
            nthItem: index
        };
        addReferrer(referrerParams);
    };

    render() {
        if (get(this.props.recommendations, 'results', []).length === 0) {
            return null;
        }
        if (isEqual(this.props.type, 'list')) {
            return (
                <RecommendationsList
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    onCardSelect={this.onCardSelect}
                    recommendations={this.props.recommendations}
                    type={this.props.type}
                    windowWidth={this.props.windowWidth} />
            );
        }
        if (isEqual(this.props.type, 'grid')) {
            return (
                <RecommendationsGrid
                    startDate={this.props.startDate}
                    endDate={this.props.endDate}
                    onCardSelect={this.onCardSelect}
                    recommendations={this.props.recommendations}
                    type={this.props.type}
                    windowWidth={this.props.windowWidth} />
            );
        }
        return null;
    }
}

Recommendations.propTypes = propTypes;

const mapStateToProps = (state) => ({
    recommendations: state.recommendations,
    auth: state.auth
});

const mapDispatchToProps = (dispatch) => ({
    getRecommendations: (options) => dispatch(getRecommendations(options))
});

export default connect(mapStateToProps, mapDispatchToProps)(Recommendations);
